module.exports = __webpack_public_path__ + "static/cheap-109d71394fc9e06604d05f841b795725.otf";